module.exports = {
          srcSet: __webpack_public_path__ + "cf91d17b.png"+" 45w",
          images:[ {path: __webpack_public_path__ + "cf91d17b.png",width: 45,height: 45}],
          src: __webpack_public_path__ + "cf91d17b.png",
          toString:function(){return __webpack_public_path__ + "cf91d17b.png"},
          
          width: 45,
          height: 45
        }